class SlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.waitForSwiper().then(() => {
      this.initializeSlideshow();
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    window.removeEventListener('resize', this.handleResize);
  }

  waitForSwiper() {
    return new Promise((resolve) => {
      if (window.Swiper) {
        resolve();
      } else {
        const checkSwiper = () => {
          if (window.Swiper) {
            resolve();
          } else {
            setTimeout(checkSwiper, 100);
          }
        };
        checkSwiper();
      }
    });
  }

  initializeSlideshow() {
    const swiperElement = this.querySelector('.slideshow-swiper');
    
    if (!swiperElement || !window.Swiper) {
      return;
    }

    const autoplay = this.dataset.autoplay === 'true';
    const delay = 5000; 
    const loop = this.dataset.loop === 'true';
    const effect = this.dataset.effect || 'slide';
    const navigation = this.dataset.navigation === 'true';

    this.swiper = new Swiper(swiperElement, {
      effect: effect,
      loop: loop,
      autoplay: autoplay ? {
        delay: delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: navigation ? {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      } : false,
      keyboard: {
        enabled: true,
      },
      a11y: {
        enabled: true,
      },
      on: {
        init: () => {
          this.updateContentSizes();
        },
        resize: () => {
          this.updateContentSizes();
        }
      }
    });

    this.handleResize = this.updateContentSizes.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  updateContentSizes() {
    const slides = this.querySelectorAll('.slideshow-slide');
    slides.forEach(slide => {
      const title = slide.querySelector('.slide-title');
      const subtitle = slide.querySelector('.slide-subtitle');
      
      if (title) {
        const titleSizeMobile = title.dataset.titleSizeMobile;
        const titleSizeDesktop = title.dataset.titleSizeDesktop;
        const fontSize = window.innerWidth >= 750 ? titleSizeDesktop : titleSizeMobile;
        title.style.fontSize = fontSize + 'px';
      }
      
      if (subtitle) {
        const subtitleSizeMobile = subtitle.dataset.subtitleSizeMobile;
        const subtitleSizeDesktop = subtitle.dataset.subtitleSizeDesktop;
        const fontSize = window.innerWidth >= 750 ? subtitleSizeDesktop : subtitleSizeMobile;
        subtitle.style.fontSize = fontSize + 'px';
      }
    });
  }

  nextSlide() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  goToSlide(index) {
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  pauseAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.pause();
    }
  }

  resumeAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.resume();
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);
